import { MultiPackageProductRouteService } from 'common/data';
import { BaseService } from 'core/services';
import _ from 'lodash';

class MultiPackageProductService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new MultiPackageProductRouteService());
	}

	create(resource, sourceOfChange) {
		var url = this.routeService.create(sourceOfChange);
		return this.apiClient.post(url, resource);
	}

	update = (resource, sourceOfChange) => {
		var url = this.routeService.update(resource, sourceOfChange);
		return this.apiClient.put(url, resource);
	};
}

export default MultiPackageProductService;
